// src/cable.js
import { createConsumer } from '@rails/actioncable';

const buildCableUrl = () => {
  const base = process.env.REACT_APP_BACKOFFICE_API_DOMAIN.replace(/\/$/, '');
  const token = localStorage.getItem('access-token');
  const url = new URL(`${base}/cable`);
  if (token) url.searchParams.set('token', token);
  return url.toString();
};

const cable = createConsumer(buildCableUrl());
export default cable;